export default __webpack_public_path__ + "static/media/settings-color-icon.1f6974a5.svg";